import type { SepaDirectDebit } from './SepaDirectDebit';

export const base: SepaDirectDebit = {
    mandateIdMatchString: /^[a-zA-Z0-9/\-?:().,'+ ]{1,35}$/i.toString(),
    separateCalculationInPaymentLists: false,
    creditorSelectSearchMinLength: 0,
    isAssistantEnabled: false,
};
